import React, { createContext, useContext, useEffect, useState } from "react";
import base from "../i18n/translations";
import extra from "../i18n/extra";

// Deep-merge extra copy into the base dictionaries (objects only; arrays replace).
function deepMerge(a, b) {
  const out = { ...a };
  for (const k of Object.keys(b)) {
    if (b[k] && typeof b[k] === "object" && !Array.isArray(b[k]) && a[k] && typeof a[k] === "object" && !Array.isArray(a[k])) {
      out[k] = deepMerge(a[k], b[k]);
    } else {
      out[k] = b[k];
    }
  }
  return out;
}

const translations = {
  en: deepMerge(base.en, extra.en),
  ar: deepMerge(base.ar, extra.ar),
};

const LanguageContext = createContext(null);

function resolve(obj, path) {
  return path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.dir = translations[lang].dir;
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const val = resolve(translations[lang], path);
    if (val !== undefined && val !== null) return val;
    const en = resolve(translations.en, path);
    return en !== undefined && en !== null ? en : path;
  };

  const toggle = () => setLang((l) => (l === "en" ? "ar" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, dir: translations[lang].dir }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
